<template>
	<div>
		<a-page-header style="background: #fff;" title="门店管理" :breadcrumb="{props:{routes:[{breadcrumbName:'首页'},{breadcrumbName:'门店管理'}]}}">
			<template slot="extra">
				<a-button type="primary" @click="addModal = true">
					添加门店
				</a-button>
			</template>
			<a-form-model layout="inline" :form="searchForm" @submit="searchSubmit">
				<a-form-model-item>
					<a-input style="width: 300px" placeholder="请输入门店名称" v-model="searchForm.word" />
				</a-form-model-item>
				<a-form-model-item>
					<a-button type="primary" html-type="submit">
						搜索
					</a-button>
				</a-form-model-item>
			</a-form-model>
		</a-page-header>

		<!-- 列表 -->
		<div class="mainBox">
			<div class="contentBox">
				<a-table :columns="columns" :dataSource="list" rowKey="id" :pagination="pagination" :loading="loading" @change="handleTableChange">
					<span slot="isOpen" slot-scope="isOpen">
						<a-tag v-if="isOpen == true" color="green">营业中</a-tag>
						<a-tag v-if="isOpen == false" color="red">暂停中</a-tag>
					</span>
					<span slot="saleInfo" slot-scope="text,saleInfo">
						<a @click="toOrderList(saleInfo.id)">{{saleInfo.orderCount}} 单</a> 
						<a-divider type="vertical" /> 
						<a @click="toOrderList(saleInfo.id)">{{saleInfo.orderAllMoney}} 元</a>
					</span>
					<span slot="wx" slot-scope="text,wx">
						<a-avatar :src="wx.leader.headpic" v-if="wx.leader.headpic" />
						{{wx.leader.nickname}}
					</span>
					<span slot="action" slot-scope="text, record">
						<a @click="toDetail(record.id)">详情</a>
						<a-divider type="vertical" />
						<a-popconfirm title="请确认是否删除？" okText="是" cancelText="否" @confirm="del(record.id)">
							<a href="javascript:;" style="color: #ff4d4f;">删除</a>
						</a-popconfirm>
					</span>
				</a-table>
			</div>
		</div>

		<!-- 添加门店弹出 -->
		<a-modal title="添加门店" v-model="addModal" @ok="addSubmit" cancelText="取消" okText="添加" width="50%">
			<a-form-model ref="addForm" :model="addForm" :rules="addRules" :label-col="{ span: 8 }" :wrapper-col="{ span: 10 }">
				<a-form-model-item label="门店名称" prop="storesName">
					<a-input v-model="addForm.storesName" />
				</a-form-model-item>
				<a-form-model-item label="门店地址" prop="storesAddress">
					<a-input v-model="addForm.storesAddress" />
				</a-form-model-item>
				<a-form-model-item label="联系电话" prop='storesTel'>
					<a-input v-model="addForm.storesTel" />
				</a-form-model-item>
				<a-form-model-item label="定位经度" prop='storesLon'>
					<a-input v-model="addForm.storesLon" />
				</a-form-model-item>
				<a-form-model-item label="定位纬度" prop='storesLat'>
					<a-input v-model="addForm.storesLat" />
				</a-form-model-item>
				<a-form-model-item label="备注" prop='storesIntro'>
					<a-input v-model="addForm.storesIntro" />
				</a-form-model-item>
			</a-form-model>
		</a-modal>
	</div>
</template>

<script>
	var storage = window.localStorage
	const columns = [{
			title: 'ID',
			dataIndex: 'id',
		},
		{
			title: '门店名称',
			dataIndex: 'storesName',
			scopedSlots: {
				customRender: 'storesName'
			},
		},
		{
			title: '门店地址',
			dataIndex: 'storesAddress',
			scopedSlots: {
				customRender: 'storesAddress'
			},
		},
		{
			title: '联系电话',
			dataIndex: 'storesTel',
			scopedSlots: {
				customRender: 'storesTel'
			},
		},
		{
			title: '销售信息',
			dataIndex: 'saleInfo',
			scopedSlots: {
				customRender: 'saleInfo'
			},
		},
		{
			title: '门店状态',
			dataIndex: 'isOpen',
			scopedSlots: {
				customRender: 'isOpen'
			},
		},
		{
			title: '绑定微信',
			dataIndex: 'wx',
			scopedSlots: {
				customRender: 'wx'
			},
		},
		{
			title: '添加时间',
			dataIndex: 'addTime',
		},
		{
			title: '操作',
			dataIndex: 'action',
			scopedSlots: {
				customRender: 'action'
			},
		},
	];

	export default {
		data() {
			return {
				columns,
				list: [],
				searchForm: {},
				pagination: {
					pageSize: 20,
					total: 0,
					current: 1
				},
				addForm: {},
				addModal: false,
				loading: false,
				addRules: {
					storesName: [{
						required: true,
						message: '请填写门店名称',
						trigger: 'blur'
					}],
					storesAddress: [{
						required: true,
						message: '请填写门店地址',
						trigger: 'blur'
					}],
					storesLon: [{
						required: true,
						message: '请填写定位经度',
						trigger: 'blur'
					}],
					storesLat: [{
						required: true,
						message: '请填写定位纬度',
						trigger: 'blur'
					}],
				},
			};
		},

		mounted() {
			this.getList()
		},

		methods: {
			toOrderList(id){
				this.$router.push('/order/OrderList?storeId=' + id)
			},
			
			toDetail(id) {
				this.$router.push('/door/doorDetail?id=' + id)
			},

			addSubmit() {
				this.$refs.addForm.validate(valid => {
					if (valid) {
						this.$http.post('/admin/index.php/admin/Shop/storesSave', {
							storesName: this.addForm.storesName,
							storesAddress: this.addForm.storesAddress,
							storesTel: this.addForm.storesTel,
							storesLon: this.addForm.storesLon,
							storesLat: this.addForm.storesLat,
							storesIntro: this.addForm.storesIntro,
						}).then(res => {
							if (res.data.code == 1) {
								this.$message.success('添加成功！');
								this.addModal = false
								this.getList()
							} else {
								this.$message.error(res.data.msg);
							}
						})
					}
				});
			},

			del(id) {
				this.$http.post('/admin/index.php/admin/Shop/storesDel', {
					id: id
				}).then((res) => {
					if (res.data.code == 1) {
						this.$message.success(res.data.msg);
						this.getList();
					} else {
						this.$message.error(res.data.msg);
					}
				})
			},

			searchSubmit(e) {
				e.preventDefault()
				this.getList()
			},

			handleTableChange(pagination, filters, sorter) {
				this.list = []
				this.pagination.current = pagination.current
				this.pagination.field = sorter.field
				this.pagination.order = sorter.order
				this.getList()
			},

			getList() {
				this.loading = true
				var data = {
					page: this.pagination.current,
					num: this.pagination.pageSize,
					field: this.pagination.field,
					order: this.pagination.order,
					word: this.searchForm.word,
				}
				this.$http.post('/admin/index.php/admin/Shop/storesList', data).then(res => {
					this.loading = false
					if (res.data.code == 1) {
						this.list = res.data.data
						this.pagination.total = res.data.count
					} else {
						this.$message.error(res.data.msg);
					}
				})
			},
		}
	}
</script>

<style scoped="">
</style>
